<template>
  <div class="attendance-container">
    <div class="attendance-card">
      <!-- Header -->
      <div class="header-section">
        <div class="logo-section">
          <i class="el-icon-s-flag"></i>
        </div>
        <h1 class="title">Daftar Hadir Event</h1>
        <p class="subtitle">Silakan isi form di bawah untuk mendaftar kehadiran</p>
      </div>

      <!-- Event Info -->
      <div v-if="eventData && !submitted" class="event-info">
        <el-alert
          :title="eventData.activity"
          type="success"
          :closable="false"
        >
          <div class="event-details">
            <p><i class="el-icon-date"></i> <strong>Tanggal:</strong> {{ eventData.date }} - {{ eventData.time }}</p>
            <p><i class="el-icon-location"></i> <strong>Tempat:</strong> {{ eventData.place }} ({{ eventData.location }})</p>
            <p><i class="el-icon-user"></i> <strong>Kapasitas:</strong> {{ eventData.capacity }} orang</p>
          </div>
        </el-alert>
      </div>

      <!-- Loading State -->
      <div v-if="loading" class="loading-section">
        <i class="el-icon-loading" style="font-size: 48px; color: #409EFF;"></i>
        <p>Memuat data event...</p>
      </div>

      <!-- Error State -->
      <div v-if="error" class="error-section">
        <el-alert
          title="Event Tidak Ditemukan"
          type="error"
          :closable="false"
          show-icon
        >
          <p>{{ error }}</p>
        </el-alert>
        <el-button type="primary" @click="$router.push('/')" style="margin-top: 20px;">
          Kembali ke Beranda
        </el-button>
      </div>

      <!-- Success State -->
      <div v-if="submitted" class="success-section">
        <div class="success-icon">
          <i class="el-icon-circle-check"></i>
        </div>
        <h2>Pendaftaran Berhasil!</h2>
        <p class="success-message">Terima kasih telah mengisi daftar hadir</p>
        
        <div class="attendance-summary">
          <h3>Detail Kehadiran Anda:</h3>
          <div class="summary-item">
            <span class="label">Nama:</span>
            <span class="value">{{ submittedData.name }}</span>
          </div>
          <div class="summary-item">
            <span class="label">NIP:</span>
            <span class="value">{{ submittedData.nip }}</span>
          </div>
          <div class="summary-item">
            <span class="label">Unit:</span>
            <span class="value">{{ submittedData.unit }}</span>
          </div>
          <div class="summary-item">
            <span class="label">Email:</span>
            <span class="value">{{ submittedData.email }}</span>
          </div>
          <div class="summary-item">
            <span class="label">No. HP:</span>
            <span class="value">{{ submittedData.phone }}</span>
          </div>
          <div class="summary-item">
            <span class="label">Waktu Daftar:</span>
            <span class="value">{{ submittedData.timestamp }}</span>
          </div>
        </div>

        <el-button type="primary" @click="$router.push('/')" style="margin-top: 20px;">
          Kembali ke Beranda
        </el-button>
      </div>

      <!-- Attendance Form -->
      <div v-if="eventData && !submitted && !loading && !error" class="form-section">
        <el-form
          :model="attendanceForm"
          :rules="attendanceRules"
          ref="attendanceForm"
          label-width="120px"
          label-position="top"
        >
          <el-form-item label="Nama Lengkap" prop="name">
            <el-input
              v-model="attendanceForm.name"
              placeholder="Masukkan nama lengkap"
              prefix-icon="el-icon-user"
            />
          </el-form-item>

          <el-form-item label="NIP" prop="nip">
            <el-input
              v-model="attendanceForm.nip"
              placeholder="Masukkan NIP"
              prefix-icon="el-icon-postcard"
            />
          </el-form-item>

          <el-form-item label="Unit Kerja" prop="unit">
            <el-select
              v-model="attendanceForm.unit"
              placeholder="Pilih unit kerja"
              style="width: 100%;"
            >
              <el-option label="Sekretariat" value="Sekretariat" />
              <el-option label="Bidang Keuangan" value="Bidang Keuangan" />
              <el-option label="Bidang IT" value="Bidang IT" />
              <el-option label="Bidang SDM" value="Bidang SDM" />
              <el-option label="Bidang Hukum" value="Bidang Hukum" />
              <el-option label="Bidang Operasional" value="Bidang Operasional" />
              <el-option label="Lainnya" value="Lainnya" />
            </el-select>
          </el-form-item>

          <el-form-item label="Email" prop="email">
            <el-input
              v-model="attendanceForm.email"
              placeholder="nama@email.com"
              prefix-icon="el-icon-message"
              type="email"
            />
          </el-form-item>

          <el-form-item label="No. HP" prop="phone">
            <el-input
              v-model="attendanceForm.phone"
              placeholder="08xxxxxxxxxx"
              prefix-icon="el-icon-phone"
            />
          </el-form-item>

          <el-form-item label="Catatan (Opsional)" prop="notes">
            <el-input
              v-model="attendanceForm.notes"
              type="textarea"
              :rows="3"
              placeholder="Tambahkan catatan jika diperlukan"
            />
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="submitAttendance"
              :loading="submitting"
              style="width: 100%;"
              size="large"
            >
              <i class="el-icon-check"></i> Daftar Hadir
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- Footer -->
      <div class="footer-section">
        <p>© 2025 Sistem Manajemen Event</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AttendanceForm',
  data() {
    return {
      loading: true,
      error: null,
      submitting: false,
      submitted: false,
      eventData: null,
      submittedData: null,
      attendanceForm: {
        name: '',
        nip: '',
        unit: '',
        email: '',
        phone: '',
        notes: ''
      },
      attendanceRules: {
        name: [
          { required: true, message: 'Nama lengkap wajib diisi', trigger: 'blur' },
          { min: 3, message: 'Nama minimal 3 karakter', trigger: 'blur' }
        ],
        nip: [
          { required: true, message: 'NIP wajib diisi', trigger: 'blur' },
          { pattern: /^[0-9]+$/, message: 'NIP harus berupa angka', trigger: 'blur' }
        ],
        unit: [
          { required: true, message: 'Unit kerja wajib dipilih', trigger: 'change' }
        ],
        email: [
          { required: true, message: 'Email wajib diisi', trigger: 'blur' },
          { type: 'email', message: 'Format email tidak valid', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: 'No. HP wajib diisi', trigger: 'blur' },
          { pattern: /^[0-9]{10,13}$/, message: 'No. HP harus 10-13 digit angka', trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    this.loadEventData();
  },
  methods: {
    loadEventData() {
      const eventId = this.$route.params.id;
      
      // Simulate API call to fetch event data
      setTimeout(() => {
        // In real app, fetch from API: axios.get(`/api/events/${eventId}`)
        // For demo, use dummy data
        const dummyEvents = [
          {
            id: 1,
            activity: 'Workshop Digital Transformation',
            date: '15/12/2025',
            time: '09:00',
            place: 'Main Hall',
            location: 'Gedung A Lt. 3',
            capacity: 50,
            status: 'Active'
          },
          {
            id: 2,
            activity: 'Seminar Nasional Kepemimpinan',
            date: '20/12/2025',
            time: '13:00',
            place: 'Auditorium',
            location: 'Gedung Utama',
            capacity: 200,
            status: 'Active'
          }
        ];

        const event = dummyEvents.find(e => e.id === parseInt(eventId));
        
        if (event) {
          this.eventData = event;
          this.loading = false;
        } else {
          this.error = 'Event dengan ID tersebut tidak ditemukan atau sudah tidak aktif.';
          this.loading = false;
        }
      }, 1000);
    },
    submitAttendance() {
      this.$refs.attendanceForm.validate((valid) => {
        if (valid) {
          this.submitting = true;

          // Simulate API call to submit attendance
          setTimeout(() => {
            // In real app: axios.post(`/api/events/${this.eventData.id}/attendance`, this.attendanceForm)
            
            this.submittedData = {
              ...this.attendanceForm,
              eventId: this.eventData.id,
              eventName: this.eventData.activity,
              timestamp: new Date().toLocaleString('id-ID', {
                dateStyle: 'long',
                timeStyle: 'short'
              })
            };

            this.submitting = false;
            this.submitted = true;

            // Show success message
            this.$message({
              type: 'success',
              message: 'Pendaftaran kehadiran berhasil disimpan!',
              duration: 3000
            });

            // Optional: Send confirmation email (backend)
            
          }, 1500);
        } else {
          this.$message.error('Mohon lengkapi semua field yang wajib diisi');
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.attendance-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.attendance-card {
  max-width: 600px;
  width: 100%;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.header-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 40px 30px;
  text-align: center;
  color: white;
}

.logo-section i {
  font-size: 64px;
  margin-bottom: 15px;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.title {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 8px;
}

.subtitle {
  margin: 0;
  font-size: 16px;
  opacity: 0.95;
}

.event-info {
  padding: 30px;
  background: #f5f7fa;
}

.event-details p {
  margin: 8px 0;
  color: #606266;
  font-size: 14px;
}

.event-details i {
  color: #67C23A;
  margin-right: 8px;
  font-size: 16px;
}

.form-section {
  padding: 30px;
}

.loading-section,
.error-section {
  padding: 60px 30px;
  text-align: center;
}

.loading-section p {
  margin-top: 20px;
  color: #606266;
  font-size: 16px;
}

.success-section {
  padding: 40px 30px;
  text-align: center;
}

.success-icon {
  margin-bottom: 20px;
}

.success-icon i {
  font-size: 80px;
  color: #67C23A;
  animation: scaleIn 0.5s ease-out;
}

@keyframes scaleIn {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.success-section h2 {
  margin: 0 0 10px 0;
  font-size: 28px;
  color: #2c3e50;
}

.success-message {
  color: #606266;
  font-size: 16px;
  margin-bottom: 30px;
}

.attendance-summary {
  background: #f5f7fa;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
  text-align: left;
}

.attendance-summary h3 {
  margin: 0 0 15px 0;
  font-size: 16px;
  color: #2c3e50;
  font-weight: 600;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #e4e7ed;
}

.summary-item:last-child {
  border-bottom: none;
}

.summary-item .label {
  color: #909399;
  font-size: 14px;
  font-weight: 500;
}

.summary-item .value {
  color: #2c3e50;
  font-size: 14px;
  font-weight: 600;
}

.footer-section {
  padding: 20px;
  text-align: center;
  background: #f5f7fa;
  border-top: 1px solid #e4e7ed;
}

.footer-section p {
  margin: 0;
  color: #909399;
  font-size: 12px;
}

::v-deep .el-form-item__label {
  font-weight: 600;
  color: #2c3e50;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  border-radius: 8px;
}

::v-deep .el-button--large {
  padding: 14px 20px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
}

@media (max-width: 768px) {
  .attendance-container {
    padding: 10px;
  }

  .header-section {
    padding: 30px 20px;
  }

  .title {
    font-size: 24px;
  }

  .form-section {
    padding: 20px;
  }
}
</style>
